import { render, staticRenderFns } from "./IconUndo.vue?vue&type=template&id=2adff8b3&"
import script from "./IconUndo.vue?vue&type=script&lang=js&"
export * from "./IconUndo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports